import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { Alert, Button, Form, Input, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import fetchMe from "../utils/fetchMe";
import GoogleOperatorAuth from "../components/auth/GoogleOperatorAuth";
import {
  clearAuthTokens,
  getOperatorAuthError,
  setLoginFlag,
  takeAuthErrorMessage,
} from "../utils/operatorAuth";
import "../assets/styles/login.scss";
import axios from "axios";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(() => takeAuthErrorMessage());
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const finishLogin = async (tokens) => {
    const user = await fetchMe(tokens.access);
    const authError = getOperatorAuthError(user);

    if (authError) {
      clearAuthTokens();
      setError(authError);
      return;
    }

    window.localStorage.setItem("access", tokens.access);
    window.localStorage.setItem("refresh", tokens.refresh);
    setLoginFlag();
    window.location.reload();
  };

  const onSubmit = async (values) => {
    setLoading(true);
    setError(null);

    try {
      const { data, status } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/jwt/create/`,
        values,
      );

      if (status === 200) {
        await finishLogin(data);
      }
    } catch (error) {
      console.log(error.response?.status, error.response?.data);

      if (
        error.response?.status === 401 &&
        error.response?.data?.detail === "-1"
      ) {
        setError("Аккаунт находится на модерации");
      } else {
        setError("Неверный пароль или логин");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page login">
      {loading && (
        <Spin
          indicator={
            <LoadingOutlined
              style={{
                fontSize: 32,
              }}
              spin
            />
          }
        />
      )}
      <div className="login__panel">
        <div className="login__panel__title">Добро пожаловать</div>
        <Form
          name="login"
          style={{ maxWidth: 300 }}
          onFinish={onSubmit}
          autoComplete="on"
          layout="vertical"
        >
          {error && (
            <div>
              <Alert message={error} type="error" showIcon />
              <br />
            </div>
          )}
          <Form.Item
            label="Логин"
            name="username"
            rules={[{ required: true, message: "Обязательное поле" }]}
          >
            <Input autoComplete="username" size="large" />
          </Form.Item>
          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: "Введите пароль" }]}
          >
            <Input.Password autoComplete="current-password" size="large" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            Войти
          </Button>
          <div className="login__divider">или</div>
          <GoogleOperatorAuth
            mode="signin"
            onError={setError}
            onLoadingChange={setLoading}
          />
          <div className="register" style={{ marginTop: "20px" }}>
            <span>Нет аккаунта?</span>&nbsp;&nbsp;
            <Link to="/registration">Зарегистрироваться</Link>
          </div>
          <div className="login__legal-links">
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Политика конфиденциальности
            </a>
            <span>/</span>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Условия пользования
            </a>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
